// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2Wfjm","search":"Settings_search__7sMY3","filter":"Settings_filter__1Ofgt"};